import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const CloudDisconnectedIcon: FC<IconProps> = (props) => {
  return (
    <svg {...initializeSvgIconProps(props)}>
      <g clipPath="url(#clip0_1950_60993)">
        <path
          d="M14.8491 5.49707C15.728 6.0646 16.5737 7.06135 16.5737 8.72949C16.5737 9.98904 16.0386 10.8727 15.2671 11.4238C14.5186 11.9585 13.5831 12.1572 12.7798 12.1572H8.0376C8.37193 11.8283 8.71299 11.494 9.05615 11.1572H12.7798C13.4403 11.1572 14.1527 10.9896 14.6851 10.6094C15.1943 10.2456 15.5737 9.66553 15.5737 8.72949C15.5737 7.3944 14.8857 6.67027 14.1753 6.25586C14.1532 6.24295 14.1301 6.23203 14.1079 6.21973C14.3748 5.95984 14.6228 5.7172 14.8491 5.49707Z"
          fill="currentColor"
        />
        <path
          d="M8.75439 2.00781C10.1362 2.00781 11.1671 2.40535 11.9077 3.01367C11.9452 3.04449 11.9803 3.07766 12.0161 3.10938C11.7933 3.32617 11.5532 3.56041 11.2983 3.80859C11.2897 3.80134 11.2817 3.79331 11.2729 3.78613C10.7327 3.34251 9.93405 3.00781 8.75439 3.00781C7.42202 3.00784 6.6458 3.45796 6.15283 4.00781C5.6396 4.58029 5.38979 5.30744 5.20947 5.93848C5.14816 6.15306 4.95216 6.30167 4.729 6.30176C4.44337 6.30176 3.71454 6.41927 3.07275 6.82031C2.45857 7.20418 1.93513 7.83485 1.93506 8.91211C1.93506 9.81768 2.347 10.3507 2.88623 10.6816C3.19339 10.8701 3.54666 10.9915 3.89307 11.0654C3.61065 11.345 3.33892 11.615 3.08057 11.8721C2.83554 11.7841 2.5921 11.6749 2.36279 11.5342C1.56023 11.0416 0.935059 10.2023 0.935059 8.91211C0.935132 7.42793 1.69294 6.50368 2.54248 5.97266C3.17466 5.57755 3.86357 5.39305 4.35107 5.3291C4.54321 4.72104 4.84247 3.97243 5.40869 3.34082C6.1051 2.56406 7.15914 2.00784 8.75439 2.00781Z"
          fill="currentColor"
        />
        <path
          d="M14.9575 2.82227C14.9575 2.82227 7.50784 10.0501 3.84668 13.7112"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1950_60993">
          <rect fill="white" height="16" transform="translate(0.754395 0.0078125)" width="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
